// Import your custom property entries.
// The entry is a text input field with logic attached to create,
// update and delete the "spell" property.
import collaborationNameProps from './Props';

import { is } from 'bpmn-js/lib/util/ModelUtil';

const LOW_PRIORITY = 500;


/**
 * A provider with a `#getGroups(element)` method
 * that exposes groups for a diagram element.
 *
 * @param {PropertiesPanel} propertiesPanel
 * @param {Function} translate
 */
export default function collaborationNameProvider(propertiesPanel, translate) {

  // API ////////

  /**
   * Return the groups provided for the given element.
   *
   * @param {DiagramElement} element
   *
   * @return {(Object[]) => (Object[])} groups middleware
   */
  this.getGroups = function(element) {

    /**
     * We return a middleware that modifies
     * the existing groups.
     *
     * @param {Object[]} groups
     *
     * @return {Object[]} modified groups
     */
    return function(groups) {

      // Add the "documents" group
      if(is(element, 'bpmn:Collaboration')) {
        groups.filter(group => group.id == 'general').forEach(group => {
          group.entries.push(collaborationNameProps(element));
        })
      }

      return groups;
    }
  };

  // registration ////////

  // Register our custom documents properties provider.
  // Use a lower priority to ensure it is loaded after
  // the basic BPMN properties.
  propertiesPanel.registerProvider(LOW_PRIORITY, this);
}

collaborationNameProvider.$inject = [ 'propertiesPanel', 'translate' ];

// Create the custom documents group
function createcallActivityGroup(element, translate) {

  // create a group called "documents properties".
  const callActivityGroup = {
    id: 'name',
    label: translate('Name'),
    entries: callActivityProps(element)
  };

  return callActivityGroup
}